var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"envelope",on:{"click":_vm.setProgress}},[_c('canvas',{ref:"canvasBackground"}),_c('div',{staticClass:"canvas-container",style:({ width: _vm.playedProgress + '%' })},[_c('canvas',{ref:"canvas"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }